// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__j-g2u","label":"Section_label__2yza2","contentWrap":"Section_contentWrap__3-AyC","footer":"Section_footer__XQ1Pm","footerInner":"Section_footerInner__6IWTw"};